import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DomainManagerService } from './service/domain-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Admin';
  data: any = false;
  domain: string = window.location.hostname;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleService: Title,
    private readonly domainService: DomainManagerService
  ) { }

  ngOnInit(): void {
    let faviconPath: string;

    if (this.domainService.isRadiologyDomain) {
      faviconPath = "./assets/image/radiology-favicon.ico";
      this.titleService.setTitle("Plus Radiology");
    } else if (this.domainService.isDoctorDomain) {
      faviconPath = "./assets/image/Plus-Doctor-favicon.ico";
      this.titleService.setTitle("Plus Doctor");
    } else {
      faviconPath = "./assets/image/favicon.ico";
      this.titleService.setTitle("Plus Physio");
    }
    this.setFavicon(faviconPath);
  }

  setFavicon(faviconUrl: string): void {
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = faviconUrl;
  }

  ngDoCheck() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.data = !this.activatedRoute.snapshot.firstChild?.routeConfig?.path?.startsWith('login') &&
          !this.activatedRoute.snapshot.firstChild?.routeConfig?.path?.startsWith('register');
      }
    });
  }
}
